// Frontend Configuration
// API URLs are injected from .env at build time via webpack (REACT_APP_* prefix required by Create React App).
// They are not secrets — they appear in every network request the browser makes.

const config = {
  apiUrl: process.env.REACT_APP_API_URL || 'http://localhost:9999',
  whoisApiUrl: process.env.REACT_APP_WHOIS_API_URL || 'http://localhost:4444',
  get backendUrl() { return this.apiUrl; },
  apiTimeout: 30000,
};

export const API_BASE_URL = config.apiUrl;
export const WHOIS_API_URL = config.whoisApiUrl;

export default config; 